import { jwtDecode } from "jwt-decode";
import { getStoredAuthToken, isAuthTokenValid } from "../../utils/authSession";

const ALLOWED_CLIENT_IDS = new Set([2, 87]);

export const canAccessGestaoCustos = () => {
  try {
    const storedToken = getStoredAuthToken();
    if (!isAuthTokenValid(storedToken)) return false;

    const token = storedToken.startsWith("Bearer ") ? storedToken.slice(7) : storedToken;
    const claims = jwtDecode(token);
    // Usa a identidade da sessão, sem liberar acesso pela empresa selecionada na interface.
    const clientId =
      claims?.id_clienteAipim ??
      claims?.id_clienteaipim ??
      claims?.idClienteAipim ??
      claims?.id_cliente ??
      claims?.idCliente ??
      claims?.cliente_id;

    if (typeof clientId !== "number" && typeof clientId !== "string") return false;
    return ALLOWED_CLIENT_IDS.has(Number(clientId));
  } catch {
    return false;
  }
};
